export default "__VITE_ASSET__BZW1Jltn__"